import React from 'react';

const Card = ({ 
  children, 
  className = '', 
  accent = false, 
  accentColor,
  shadow = true,
  ...props 
}) => {
  let accentStyles = '';
  
  if (accent) {
    if (accentColor) {
      accentStyles = `border-t-4 border-${accentColor}`;
    } else {
      accentStyles = 'border-t-4 border-primary';
    }
  }
  
  const shadowStyles = shadow ? 'shadow-md' : '';
  
  return (
    <div 
      className={`bg-white rounded-xl overflow-hidden ${accentStyles} ${shadowStyles} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '', ...props }) => {
  return (
    <div className={`p-6 ${className}`} {...props}>
      {children}
    </div>
  );
};

export const CardTitle = ({ children, className = '', ...props }) => {
  return (
    <h3 className={`text-xl font-semibold text-primary mb-2 ${className}`} {...props}>
      {children}
    </h3>
  );
};

export const CardContent = ({ children, className = '', ...props }) => {
  return (
    <div className={`p-6 pt-0 ${className}`} {...props}>
      {children}
    </div>
  );
};

export const CardFooter = ({ children, className = '', ...props }) => {
  return (
    <div className={`p-6 pt-0 ${className}`} {...props}>
      {children}
    </div>
  );
};

export default Card;